import { ModalProvider } from 'modules/templateEditor/context';
import { CampaignQueryContextProvider } from 'modules/templateEditor/context/CampaignQueryContextProvider';
import { EditableFieldsContextProvider } from 'modules/templateEditor/context/EditableFieldsContextProvider';
import { EditorFormProvider } from 'modules/templateEditor/context/EditorFormProvider';
import { EditSavedRowDesignProvider } from 'modules/templateEditor/context/EditSavedRowDesignContext';
import { ErrorValidationContextProvider } from 'modules/templateEditor/context/ErrorValidationContext';
import { MessageTypesQueryContextProvider } from 'modules/templateEditor/context/MessageTypesQueryContextProvider';
import { PreviewWithDataContextProvider } from 'modules/templateEditor/context/PreviewWithDataContextProvider';
import { SendTestMsgContextProvider } from 'modules/templateEditor/context/SendTestMsgContextProvider';
import { TemplateQueryContextProvider } from 'modules/templateEditor/context/TemplateQueryContextProvider';
import { Modals } from 'modules/templateEditor/modals';
import { FC } from 'react';
import { JsonViewModeContextProvider, ViewTypes } from 'ui/treeView';
import { LocaleSettingsContextProvider } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';
import { LocalesQueryContextProvider } from 'modules/campaigns/lib/contexts/LocalesQueryContext';
import { ModalContextProvider } from 'utils/contexts/modal';
import { InStudioTemplateProps } from '../InStudioTemplateEditing';
import { TemplateStateContextProvider } from './TemplateStateContextProvider';

export const CampaignEditorTemplateContextProvider: FC<
  React.PropsWithChildren<InStudioTemplateProps>
> = ({ children, ...props }) => (
  <TemplateStateContextProvider
    {...{ campaignId: props?.campaignId, templateId: props?.templateId }}
  >
    <LocaleSettingsContextProvider>
      <LocalesQueryContextProvider>
        <CampaignQueryContextProvider>
          <TemplateQueryContextProvider>
            <EditorFormProvider>
              <ErrorValidationContextProvider>
                <MessageTypesQueryContextProvider>
                  <EditableFieldsContextProvider>
                    <PreviewWithDataContextProvider>
                      {/*
                       * `ModalContextProvider` usage in here has been  deprecated and will be removed in the future,
                       * please use `ModalProvider`for all new modal management features
                       * @see src/modules/templateEditor/context/ModalContext.ts
                       */}
                      <ModalContextProvider>
                        <ModalProvider>
                          <SendTestMsgContextProvider>
                            <JsonViewModeContextProvider
                              identifier="raw-data"
                              defaultMode={ViewTypes.raw}
                            >
                              <EditSavedRowDesignProvider>
                                {children}
                                <Modals />
                              </EditSavedRowDesignProvider>
                            </JsonViewModeContextProvider>
                          </SendTestMsgContextProvider>
                        </ModalProvider>
                      </ModalContextProvider>
                    </PreviewWithDataContextProvider>
                  </EditableFieldsContextProvider>
                </MessageTypesQueryContextProvider>
              </ErrorValidationContextProvider>
            </EditorFormProvider>
          </TemplateQueryContextProvider>
        </CampaignQueryContextProvider>
      </LocalesQueryContextProvider>
    </LocaleSettingsContextProvider>
  </TemplateStateContextProvider>
);
